var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotel3 = function SvgHotel3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24.5V5.833A2.333 2.333 0 0 1 5.834 3.5h16.333A2.333 2.333 0 0 1 24.5 5.833V24.5m0-12.833h-7l-3.5-3.5-3.5 3.5h-7M16.334 24.5v-5.833h-4.667V24.5m-5.25-9.333H8.75m-2.333 3.5H8.75m10.5-3.5h2.334m-2.334 3.5h2.334m-8.75-3.5h2.333M2.334 24.5h23.333"
  })));
};
export default SvgHotel3;